import React from 'react';
import {Title, TitleSize} from '@treez-ui/core/layout/Title';
import {AddIcon} from '@treez-ui/core/icons';
import {BrandTreezLogoWhite} from '~/modules/icons/BrandTreezLogo';

interface Props {
    redirectToBrandTreez: () => void;
    openProductForm: () => void;
}

export const BrowseBrandTreezPrompt = (props: Props) => {
    const {openProductForm, redirectToBrandTreez} = props;

    return (
        <div className="browse-brand-treez-prompt">
            <button onClick={redirectToBrandTreez} className="browse-brand-treez-button clickable">
                <Title text="Browse" size={TitleSize.MEDIUM} />
                <BrandTreezLogoWhite />
            </button>
            <button className="create-new-product-button clickable" onClick={openProductForm}>
                <AddIcon color="white" />
                <div className="button-prompt"> Create New Product </div>
            </button>
        </div>
    );
};

export default BrowseBrandTreezPrompt;
